<template>
  <div>
    <v-text-field v-model="coupon" :label="$t('Your discount coupon')" />
    <v-row align="center" justify="center">
      <v-col v-for="plan in plans" :key="plan.id" class="col-12 col-lg-6 col-md-6">
        <v-card class="my-4 pa-2" height="40vh" outlined>
          <v-card-title class="title mt-3">{{ plan.name }}</v-card-title>

          <v-card-text class="text--primary justify-center body-1">{{ plan.description }}</v-card-text>
          <!-- <v-card-text class="text--primary justify-center">
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title class="grey--text"
                    >Gestor de Menu</v-list-item-title
                  >
                  <div>Cambios ilimitados en tu menú</div>
                </v-list-item-content>
              </v-list-item>
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title class="grey--text"
                    >Localizaciones</v-list-item-title
                  >
                  <div>Hasta 20 localizaciones QR diferentes</div>
                </v-list-item-content>
              </v-list-item>
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title class="grey--text"
                    >Llamar al Camarero</v-list-item-title
                  >
                  Tus clientes pueden llamar al camarero desde su mesa
                </v-list-item-content>
              </v-list-item>
              <v-card-title>Sin coste de implantación</v-card-title>
          </v-card-text>-->

          <v-card-actions class="d-flex justify-end bottom-0" style="position: absolute;bottom: 0;">
            <Checkout :price="price" :coupon="coupon" v-for="price in plan.prices" :key="price.id" />
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Checkout from "@/stripe/Checkout";
export default {
  components: { Checkout },
  data: () => ({
    loading: false,
    hasNotAPlan: true,
    coupon: ""
  }),
  methods: {},
  computed: {
    locale() {
      // console.log("locale");
      return this.$i18n.locale.split("-")[0];
    },
    plans() {
      return this.$store.getters.plans;
    }
  },

  mounted() {
    this.$store.dispatch("bindProductPlans");

    // this.getSku();
  },
  destroyed() {}
};
</script>
